import React, { useState } from 'react';
import OwlCarousel from 'react-owl-carousel';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { addfilter } from '../../../../Reducer/productReducer';

const ProductfiltersOffer1 = ({ data, index, handleClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const addedfilter = useSelector(
    (state) => state.persistedReducer.product.addedfilter,
  );
  const checkboxcheck = (title, value, i) => {
    var data = false;
    if (addedfilter[i]?.title == title) {
      if (addedfilter[i]?.filter?.includes(`${value}`)) {
        data = true;
      }
    }
    return data;
  };
  const handlecheckChange = (title, value, name) => {
    var changedata = [...addedfilter];
    addedfilter?.map((val) => {
      //------------ multi select ------------
      var filterdata = [...val.filter];
      var fname = [...val.name];

      ///------------ single select ---------------
      // var filterdata = [];
      // var fname = [];

      if (val.title == title) {
        if (val?.filter?.includes(value)) {
          filterdata = val.filter?.filter((data) => data !== value);
          fname = val.name?.filter((data) => data !== name);
        } else {
          filterdata.push(value);
          fname.push(name);
        }
        changedata = changedata?.map((obj) =>
          obj.title == title
            ? Object.assign({}, obj, { filter: filterdata, name: fname })
            : obj,
        );
        dispatch(addfilter(changedata));
      }
    });
  };
  const options = {
    loop: false,
    items: 8,
    margin: 0,
    autoplay: false,
    dots: false,
    nav: true,
    autoWidth: true,
    // autoWidth:data?.title == 'Collection' || data?.title == 'Gemstone' ? true : false,
  };
  //   console.log(data.title)
  const redirect = (val) => {
    navigate(val);
  };
  return (
    <div className="style_filter">
      <ul
        className={
          data?.data?.length > 10
            ? 'max-item mobile_hide'
            : 'min-item mobile_hide'
        }
      >
        <OwlCarousel {...options} className="owl-carousel owl-theme">
          {data?.data?.map((value) => (
            <li data-url={value?.url}
              key={value?.id}
              className={value.status == 0 ? 'filterdisable' : ''}
            >
              <label
                onClick={(e) =>
                  value?.type == 2
                    ? redirect(
                        value?.selected && data?.title === 'Type'
                          ? '/special/fine-jewelry'
                          : value?.url,
                      )
                    : handlecheckChange(data?.title, value?.value, value?.name)
                }
                className={
                  checkboxcheck(data?.title, value?.value, index)
                    ? 'btn btn-outline-defult active'
                    : 'btn btn-outline-defult'
                }
              >
                <h2>{value.name}</h2>
                {value.icon?.length ? (
                  <>
                    <br />
                    <img src={value.icon} alt={value.name} />
                  </>
                ) : data?.title == 'Metal' ? (
                  <div className="metal_box_noimg">
                    {String(value.name.split(' ').slice(0, 1)).slice(0, 1)}
                    {String(value.name.split(' ').slice(1, 2)).slice(0, 1)}
                  </div>
                ) : (
                  ''
                )}
              </label>
            </li>
          ))}
        </OwlCarousel>
      </ul>

      <ul className="desktop_hide">
        {data?.data?.map((value) => (
          <li
            key={value?.id}
            className={value.status == 0 ? 'filterdisable' : ''}
            onClick={handleClose}
          >
            <label
              onClick={(e) =>
                value?.type == 2
                  ? redirect(
                      value?.selected && data?.title == 'Type'
                        ? '/special/fine-jewelry'
                        : value?.url,
                    )
                  : handlecheckChange(data?.title, value?.value, value?.name)
              }
              className={
                checkboxcheck(data?.title, value?.value, index)
                  ? 'btn btn-outline-defult active'
                  : 'btn btn-outline-defult'
              }
            >
              <h2>{value.name}</h2>
              {value.icon?.length ? (
                <>
                  <br />
                  <img src={value.icon} alt='wedding day diamonds' />
                </>
              ) : (
                ''
              )}
            </label>
            
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProductfiltersOffer1;
